import React from "react";
import BackHeader from "./BackHeader";

const MobileMorePage = ({ onTabChange, onDeleteTrip }) => {

  const items = [
    { id: "tickets", label: "Tickets" },
    { id: "stays", label: "Accommodation" },
    { id: "documents", label: "Documents" },
    { id: "share", label: "Share Trip" },
    { id: "invite", label: "Invite Friends" },
    { id: "help", label: "Help" }
  ];

  return (
    <div className="space-y-4 max-w-4xl mx-auto">
      {onTabChange && (
        <BackHeader title="More Options" onBack={() => onTabChange("overview")} />
      )}

      {items.map((item) => (
        <button
          key={item.id}
          onClick={() => onTabChange(item.id)}
          className="w-full bg-white border border-gray-100 rounded-xl p-4 text-left font-semibold hover:bg-gray-50 transition"
        >
          {item.label}
        </button>
      ))}

      <button
        onClick={onDeleteTrip}
        className="w-full mt-6 bg-red-50 border border-red-200 text-red-600 rounded-xl p-4 font-bold"
      >
        Delete Trip
      </button>

    </div>
  );
};

export default MobileMorePage;